import { render } from "./HeroiconsOutlineShoppingBag.vue?vue&type=template&id=77c4bd0a"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShoppingBag.vue"]])

export default __exports__